// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button--primary:focus,.el-button--primary:hover{background-color:#f32c6c!important;border:1px solid #f32c6c!important;border-color:#f32c6c!important}.renameDialog{overflow:hidden}.renameDialog .el-dialog__body{padding:0!important}.renameDialog .el-dialog{margin-top:10vh!important}", ""]);
// Exports
module.exports = exports;
